var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33569",
    "data-name": "Group 33569",
    transform: "translate(126 136) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(108 118)",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(125.03 135.037) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67897",
    "data-name": "Path 67897",
    d: "M8.92,2.9l.015,9.824h2.008l-.015-9.811,1.85,1.848L14.2,3.344,11.574.723a2.342,2.342,0,0,0-3.313,0L5.639,3.346,7.058,4.764Z",
    transform: "translate(17.971 12.764) rotate(180)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67898",
    "data-name": "Path 67898",
    d: "M14.054,16v3.346H2.008V16H0v3.346a2.008,2.008,0,0,0,2.008,2.008H14.054a2.008,2.008,0,0,0,2.008-2.008V16Z",
    transform: "translate(0 -5.28)",
    fill: "#5076ba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.79b404860db9cad9df4f686eb964f515.svg";
export { ForwardRef as ReactComponent };